import { render, staticRenderFns } from "./BusinessTask.vue?vue&type=template&id=7b066a60"
import script from "./BusinessTask.vue?vue&type=script&lang=js"
export * from "./BusinessTask.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports